import { memo } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { Mail, Phone, AtSign, Globe, User, Image, Link2, Shield } from 'lucide-react'

const ENTITY_ICONS: Record<string, typeof Mail> = {
  email: Mail,
  phone: Phone,
  username: AtSign,
  domain: Globe,
  person: User,
  image_url: Image,
  url: Link2,
  account: AtSign,
  post: Link2,
  breach_hub: Shield,
}

const ENTITY_COLORS: Record<string, string> = {
  email: '#3b82f6',
  phone: '#22c55e',
  username: '#f59e0b',
  domain: '#8b5cf6',
  person: '#ec4899',
  image_url: '#06b6d4',
  url: '#6366f1',
  account: '#1da1f2',
  post: '#657786',
  breach_hub: '#94a3b8',
  unknown: '#64748b',
}

function EntityNode({ data, selected }: NodeProps) {
  const entityType = (data?.entity_type as string) ?? 'unknown'
  const label = (data?.label as string) ?? (data?.value as string) ?? 'entity'
  const Icon = ENTITY_ICONS[entityType] ?? Globe
  const color = ENTITY_COLORS[entityType] ?? ENTITY_COLORS.unknown

  return (
    <div
      className={`
        px-4 py-2 rounded-lg shadow-lg border-2 min-w-[120px] max-w-[200px]
        transition-all duration-200
        ${selected ? 'ring-2 ring-primary ring-offset-2 ring-offset-slate-950' : ''}
      `}
      style={{
        backgroundColor: `${color}20`,
        borderColor: color,
      }}
    >
      <Handle type="target" position={Position.Top} className="!bg-slate-500" />
      <div className="flex items-center gap-2">
        <Icon className="w-4 h-4 shrink-0" style={{ color }} />
        <div className="min-w-0">
          <p className="text-[10px] uppercase font-medium opacity-80" style={{ color }}>
            {entityType}
          </p>
          <p className="text-sm font-medium truncate" title={label}>
            {label}
          </p>
        </div>
      </div>
      <Handle type="source" position={Position.Bottom} className="!bg-slate-500" />
    </div>
  )
}

export default memo(EntityNode)
